const WepHtmlToString = {
  mainTemplate: '',
  firstSubTemplate: '',
  secondSubTemplate: '',
  thirdSubTemplate: '',
  fourthSubTemplate: '',
  fifthSubTemplate: '',
  sixthSubTemplate: '',
  seventhSubTemplate: '',
  eighthSubTemplate: '',
  ninthSubTemplate: '',
  tenthSubTemplate: '',
  mainTemplateFile: ''
}

export default WepHtmlToString



// WEBPACK FOOTER //
// ./src/plugins/_common/WepHtmlToString.js